(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cp-testimonial-carousel"] && !Shopify.designMode) return;
  try {
    if (!window.__cpTestimonialCarouselBound) {
    window.__cpTestimonialCarouselBound = true;
    document.addEventListener('click', function(event) {
      var button = event.target.closest('[data-cp-prev], [data-cp-next]');
      if (!button) return;
      var carousel = button.closest('[data-cp-testimonial-carousel]');
      if (!carousel) return;
      var track = carousel.querySelector('[data-cp-track]');
      if (!track) return;
      var card = track.querySelector('[data-cp-card]');
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 14;
      var distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: button.hasAttribute('data-cp-next') ? distance : -distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
